/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import QasClient from 'mbp-address-verification';

export const qasSearchAddress =  ({ queryKey: [_, queryType, params] }) => {
    return QasClient.qasGet({}, queryType, params, true).then((response) => response);
};